import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppService } from './app.service';
import { DeepstreamService } from './deepstream/deepstream.service';
import { AuthService } from './auth/auth.service';
import { UserService } from './user/user.service';
import { OrganizationService } from './organization/organization.service';
import { SearchService } from './search/search.service';
import { DeviceService } from './devices/device.service';
import { LocationService } from './locations/location.service';
import { NotificationService } from './shared/notification/notification.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class AppServicesModule {
  static forRoot(): ModuleWithProviders<NgModule> {
    return {
      ngModule: AppServicesModule,
      providers: [
				AppService,
        DeepstreamService,
				AuthService,
        UserService,
        OrganizationService,
        SearchService,
        DeviceService,
        LocationService,
        NotificationService
      ]
    }
  }
}
